import React, { memo, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Avatar, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { getPersonInitials } from 'utils/loanApplication';

import { selectPresenceUserIdColorMap } from 'store/presence/selectors';

import { avatarStyles, getToastAvatarBorderStyles } from './PresenceToast.styles';

const ToastNotification = memo(({ displayName, firstName, lastName, avatarUrl, userId }) => {
  const userColorMap = useSelector(selectPresenceUserIdColorMap);
  const userColor = userColorMap[userId]?.bg;

  const combinedAvatarStyles = useMemo(
    () => ({ ...avatarStyles, ...getToastAvatarBorderStyles(userColor) }),
    [userColor],
  );

  return (
    <>
      <Avatar alt={displayName} src={avatarUrl} sx={combinedAvatarStyles}>
        {getPersonInitials({ firstName, lastName })}
      </Avatar>
      <Typography color="text.primary" component="span" variant="bold14">
        {displayName}
      </Typography>
    </>
  );
});

ToastNotification.displayName = 'ToastNotification';

ToastNotification.propTypes = {
  displayName: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  avatarUrl: PropTypes.string,
  userId: PropTypes.string,
};

export default ToastNotification;
